export default function KidsPartyContentSection() {
  return (
    <section className="py-6 md:py-16 bg-[#FCF8F8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center event-box1">
          {/* Left Content */}
          <div className="space-y-8">
            <h1 className="text-4xl font-bold text-[#00889D]">
              Kids Party
            </h1>

            <div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Celebrate your child's special day in a fun, healthy, and creative way!
                Our studio offers an unforgettable birthday experience where kids can enjoy
                <span className="text-[#00889D] font-semibold"> Dance/Fitness, Yoga or Theme Party</span>.
                Each celebration is filled with movement, laughter, and mindful fun—keeping kids active, happy, and
                inspired!
              </p>

              <h3 className="text-2xl text-[#00889D] font-bold mb-2">Cost: $499 per party</h3>
            </div>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>Duration:</strong> 2 hours</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>1 hour of workshop</strong> of your choice (Yoga, Fitness, Dance)
                </p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>1 hour of celebration</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>$100 for 1 extra hour</strong> of celebration, or animator</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>max 20 children capacity</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">Parties are held on <strong className="text-[#00889D]">Saturday,
                  Sunday</strong> afternoon</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">Feel free to bring cake, snacks and refreshments. Pizza pizza is just next
                  door</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">Let us know if you want recommendations for <span
                    className="text-[#00889D] font-semibold">very special cake</span></p>
              </div>
            </div>
          </div>

          {/* Right Images */}
          <div className="space-y-6">
            <div className="rounded-lg overflow-hidden shadow-lg">
              <img
                  src="/img/kidsparty1.png"
                  alt="Kids enjoying yoga party"
                  className="w-full h-64 object-cover object-top"
              />
            </div>

            <div className="rounded-lg overflow-hidden shadow-lg">
              <img
                  src="/img/kidsparty2.png"
                  alt="Children celebrating birthday party"
                  className="w-full h-64 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}